import { render, staticRenderFns } from "./enterinput.vue?vue&type=template&id=22475f08&scoped=true"
import script from "./enterinput.vue?vue&type=script&lang=js"
export * from "./enterinput.vue?vue&type=script&lang=js"
import style0 from "./enterinput.vue?vue&type=style&index=0&id=22475f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22475f08",
  null
  
)

export default component.exports